module.exports = __webpack_public_path__ + "735c59a38b2a659a4892e3420e26f90b.png";